import { VehicleProvider, VehicleSource } from '@cbgms/api'
import { useOrderAccountsContext } from 'app/workorder/contexts/use-order-account-context'

const VehicleSourceToProvider: Record<VehicleSource, VehicleProvider | undefined> = {
  [VehicleSource.Unconfigured]: VehicleProvider.Hbase,
  [VehicleSource.CARSYS_HBASE]: VehicleProvider.Hbase,
  [VehicleSource.CARSYS_EMDM]: VehicleProvider.Mdm,
  [VehicleSource.VPOM_EMDM]: VehicleProvider.Mdm,
  [VehicleSource.VPOM_TecDocPlus]: VehicleProvider.TecDocPlus,
  [VehicleSource.VPOM_Hbase]: VehicleProvider.Hbase,
  [VehicleSource.CARSYS_RDW]: VehicleProvider.Rdw,
  [VehicleSource.CARSYS_VIS_RDW]: VehicleProvider.VisRdw,
  [VehicleSource.CARSYS_AAA]: VehicleProvider.TripleAAA
}

export const useDefaultOrderAccountVehicleProvider = () => {
  const { selectedOrderAccount } = useOrderAccountsContext()
  const provider = VehicleSourceToProvider[selectedOrderAccount?.Catalog?.VehiclePrimaryVehicleSource] || VehicleProvider.Hbase
  return provider
}
